<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav class="hideOnPrint"/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                        :headers="headers"
                        :items="nevadaIncidents"
                        sort-by="IncidentDate"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Incident Reports"
                        :search="search"
                        height="550"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Incident Reports</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="desktop"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn
                                    fab
                                    small
                                    @click="printTable()"
                                    class="mr-8 mb-2 white--text"
                                    color="#2b6993"
                                    elevation="4"
                                >
                                    <v-icon>print</v-icon>
                                </v-btn>
                                <v-btn color="#2b3990" dark class="mb-2" @click="showAdd()">
                                    <v-icon left>add</v-icon>
                                    Add Incident Report
                                </v-btn>
                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="mobile ml-5 mr-5 mb-3 mt-3"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
      <span v-if="item.Document != null">
          <v-icon small class="mr-2" @click="downloadDocument(item)">
              mdi-download
          </v-icon>
      </span>

                            <v-icon small class="mr-2" @click="viewIncident(item)" v-if="!DCA">
                                mdi-eye
                            </v-icon>
                            <v-icon small @click="deleteIncident(item)" v-if="!DCA">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="#2b3990" class="white--text" @click="getIncidents()">Reset</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <div id="printTable">
            <h2 class="text-center ma-3">Incident Report</h2>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="nevadaIncidents"
                        sort-by="Type"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Incident Reports"
                        :search="search"
                        height="auto"
                        hide-default-footer
                        disable-pagination
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Incident Reports</v-toolbar-title>
                            </v-toolbar>

                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import renameFileHelper from '../../mixins/renameFileHelper'
import Swal from 'sweetalert2'


const url = require("../../client_config/config").url;

export default {
    mixins: [renameFileHelper],
    components: {
        ClientNav,
        ClientSide,
        Foot,
    },
    data() {
        return {
            headers: [
                {
                    text: 'Incident Category',
                    align: 'start',
                    sortable: true,
                    value: 'Type',
                },
                {text: "Incident Date", value: "IncidentDate"},
                {text: "Program Type", value: "ProgramType"},
                {text: "Incident Type", value: "IncidentType"},
                {text: "Reporters Signature", value: "ReportersSignature"},
                {text: "Submitted to State", value: "Compliance"},

                {text: "Actions", value: "actions", sortable: false},
            ],
            nevadaIncidents: [],
            units: [],
            users: [],
            msg: false,
            text: "",
            search: "",
            clientID: this.$route.params.clientID,
            userState: localStorage.getItem('userState'),
            isLoading: true,
            page: 1,
            pageCount: 1,
            itemCount: 0,
            options: {},
            userRole: localStorage.getItem('userRole'),
            DCA: false,
        };
    },

    computed: {
        formTitle() {
            return this.editedIndex !== 1 ? "New Item" : "Edit Item";
        },

        clientName() {
            // `this` points to the component instance
            return this.$store.state.clients.client.Name;
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        options: {
            handler() {
                this.getIncidents();
            },
            deep: true
        },
    },

    created() {
        this.getIncidents();
        this.getUsers();
        this.getPrograms();
        if(this.userRole === 'Direct Care Staff'){
            this.DCA = true;
        }
    },

    methods: {
        initialize() {
            this.incidents = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        validateReset() {
            if (this.$refs.form !== undefined) {
                this.$refs.form.reset();
            }
        },

        getPrograms() {
            axios.get(`${url}/units/state/${this.userState}`).then(async res => {
                this.programs = res.data.units;

            });
        },

        viewIncident(item) {
            this.$router.push({
                path: `/nvIncidents/${this.clientID}/update-incident/${item._id}`,
                query: {newIncident: 'false'}
            });
        },

        showAdd() {
            this.$router.push({
                path: `/nvIncidents/${this.clientID}/add-incident`,
                query: { newIncident: 'true' }
            });
        },

        deleteIncident(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this incident?") &&
            this.incidentDelete(id);
        },

        downloadDocument(url) {
            if (url) {
                window.open(url, '_blank');
            } else {
                alert('No documents available');
            }
        },

        incidentDelete(id) {

            Swal.fire({
                title: 'Please wait...',
                text: 'Deleting incident...',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });

            axios.delete(`${url}/nevadaIncidents/${id}`)
                .then((response) => {
                        Swal.close();
                        this.getIncidents();
                        if (response.status === 400) {
                            response.json().then(function (data) {
                                Swal.fire({
                                    title: 'Error!',
                                    text: data.msg,
                                    icon: 'error',
                                    confirmButtonText: 'OK'
                                });
                            });
                        } else {
                            Swal.fire({
                                title: 'Deleted!',
                                text: 'The incident has been deleted successfully.',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            });
                        }
                })
                .catch((error) => {
                    let errorMessage = 'An error occurred while deleting the incident.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    } else if (error.message) {
                        errorMessage = error.message;
                    }
                    Swal.fire({
                        title: 'Error!',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                });
        },

        getIncidents() {
            this.isLoading = true;

            let {page, itemsPerPage} = this.options;
            page = page || 1;
            itemsPerPage = itemsPerPage || 10;

            const params = {
                page: page,
                limit: itemsPerPage,
            };

            axios.get(`${url}/nevadaIncidents/client/${this.clientID}`, {params}).then(response => {
                const {docs, totalPages, totalDocs} = response.data;
                this.nevadaIncidents = docs;

                for (let i = 0; i < this.nevadaIncidents.length; i++) {
                    this.nevadaIncidents[i].IncidentDateTimeTable = moment(this.nevadaIncidents[i].IncidentDateTime).format("YYYY-MM-DD");
                }

                this.pageCount = totalPages;
                this.itemCount = totalDocs;

                this.getUnits()
            }).finally(() => this.isLoading = false);
        },

        getUnits() {
            axios.get(`${url}/units`).then(async res => {
                res.data.units.forEach(item => {
                    this.units.push(item.Name)
                })
            });
        },

        getCodes: function () {
            axios.get(`${url}/codes`).then(async res => {
                this.codes = res.data.codes;
            });
        },

        getUsers() {
            axios.get(`${url}/users`).then(async res => {
                this.users = res.data.users;
                for (let i = 0; i < this.users.length; i++) {
                    if (this.userID === this.users[i]._id) {
                        this.staff = this.users[i].Name
                    }
                }
            });
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()

        },

    },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;


    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>
